/**
 * IdleLogoutWarning — mounts the idle-logout tracker for the authenticated
 * app shell and renders the "you're about to be signed out" dialog.
 *
 * Wired once in routes/app/_layout.tsx (AppLayout), inside its final
 * protected-render branch — see lib/use-idle-logout.ts for the timer /
 * multi-tab mechanics. Mirrors the StepUpModalHost idiom
 * (components/auth/step-up-modal.tsx): a single always-mounted host reading
 * its own hook state, built on the shared ui/modal.tsx so it matches every
 * other dialog in the product.
 */

import { Modal } from './ui/modal';
import { useIdleLogout } from '../lib/use-idle-logout';

export function IdleLogoutWarning({ enabled = true }: { enabled?: boolean }) {
  const { warningOpen, stayActive } = useIdleLogout(enabled);

  return (
    <Modal
      open={warningOpen}
      onClose={stayActive}
      title="Still there?"
      size="sm"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, paddingBottom: 20 }}>
        <p style={{ fontSize: 13.5, color: 'var(--ink-2)', lineHeight: 1.55, margin: 0 }}>
          You’ll be signed out in 60 seconds due to inactivity. Still there?
        </p>
        <button
          type="button"
          onClick={stayActive}
          style={{
            alignSelf: 'flex-start',
            padding: '12px 18px',
            borderRadius: 10,
            border: 'none',
            background: 'var(--accent-400)',
            color: 'var(--primary-900)',
            fontFamily: 'var(--sans)',
            fontSize: 14.5,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Stay signed in
        </button>
      </div>
    </Modal>
  );
}
